export enum TRANSLATION {
  removed = '_COMMON_AREA_MESSAGE_REMOVED',
  saved = '_COMMON_AREA_MESSAGE_SAVED',
  created = '_COMMON_AREA_MESSAGE_CREATED',
}